import * as Styled from "./AdBanner.styled";
import { InfoCircle } from "react-bootstrap-icons";

export const AdBanner: React.FC<{
    source: string;
    url: string;
    altText: string;
}> = ({ source, url, altText }) => {
    return (
        <Styled.AdBannerContainer>
            <a href={url} target="_blank" rel="noreferrer">
                <Styled.AdBanner>
                    <Styled.AdNotice>
                        <InfoCircle style={{ marginRight: "3px" }} />
                        Sponsored
                    </Styled.AdNotice>
                    <Styled.AdBannerImg src={source} alt={altText} />
                </Styled.AdBanner>
            </a>
        </Styled.AdBannerContainer>
    );
};
